import Swiper from 'swiper/bundle';

// 画像の読み込み完了を待たずに初期化する(低速回線でバナーが静止画のままになる時間を短縮)
window.addEventListener('DOMContentLoaded', () => {
  const bannerCarousel = document.querySelector('.konintodoke-banner-carousel__container')

  if (!bannerCarousel) return

  new Swiper(bannerCarousel, {
    loop: true,
    slidesPerView: 1,
    centeredSlides: true,
    speed: 1000,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.konintodoke-banner-carousel__pagination',
      clickable: true,
      bulletClass: 'konintodoke-banner-carousel__bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
      renderBullet(index, className) {
        return `<span class="${className}"><span class="konintodoke-banner-carousel__bullet-dot"></span><svg class="konintodoke-banner-carousel__bullet-heart" viewBox="0 0 12 11" xmlns="http://www.w3.org/2000/svg"><path d="M6 10.4C2.6 7.5 0.5 5.6 0.5 3.3C0.5 1.5 1.9 0.1 3.7 0.1C4.7 0.1 5.6 0.6 6 1.3C6.4 0.6 7.3 0.1 8.3 0.1C10.1 0.1 11.5 1.5 11.5 3.3C11.5 5.6 9.4 7.5 6 10.4Z"/></svg></span>`
      },
    },
  })
})
